import { makeStyles } from "@material-ui/core/styles";
import { createTheme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  headers: {
    display: "flex",
    flexDirection: "row",
  },
  detailHeaders: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    width: "40%",
  },
  otherHeaders: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    width: "60%",
  },
  details: {
    display: "flex",
    flexDirection: "row",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  cloneButton:{
    backgroundColor: "#022F40 !important",
		color: "white",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
    height: "600px",
  },
  vendorSelectStyle: {
    color: "#000000",
    width: "100%",
    textAlign: "left",
  },
  vendorSubtitle2: {
    display: "inline-block",
    marginTop: ".25rem",
  },
  vendorLocationTitle: {
    display: "inline-block",
    marginTop: ".25rem",
  },
  vendorDialog: {
    zIndex: "1000 !important",
    // "& .pac-container": {
    // 	zIndex: "99999 !important"
    // }
  },
  vendorDialogContent: {
    "& .asset-MuiTextField-root": {
      margin: 0,
    },
  },
  vendorDialogButton: {
    borderRadius: 0,
    margin: ".5rem 0",
    backgroundColor: "#3f50b5",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#002984",
    },
  },
  vendorDialogAction: {
    display: "block",
    textAlign: "center",
  },
  boxDesign: {
    border: "1px solid rgba(224, 224, 224, 1)",
    padding: 5,
    marginTop: 0,
    marginBottom: "0.75rem",
  },
  innerBoxDesign: {
    borderRight: "1px solid rgba(224, 224, 224, 1)",
  },
  borderBottom: {
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    marginBottom: "0.25rem",
  },
}));

export const assetDetailsTheme = createTheme({
  overrides: {
    MuiMenuItem: {
      root: {
        fontSize: "0.875rem",
        color: "#000000",
      },
    },
  },
});

export const sellingDetailsTheme = createTheme({
  palette: {
    // primary: {
    // 	main: "#00FF00"
    // }
  },
  overrides: {
    MuiFormControl: {},
    MuiMenuItem: {
      root: {
        fontSize: "0.875rem",
        color: "#000000",
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: "0.875rem",
        textAlign: "justify",
      },
    },

    // MuiCheckbox: {
    // 	checked: {
    // 		color: "#FF0000 !important"
    // 	}
    // }
  },
});
